import imageCompression from "browser-image-compression";

type FileEventTarget = EventTarget & { files: FileList };

async function getBase64DataFromFileSelection(
  e: React.ChangeEvent<HTMLInputElement>
): Promise<string> {
  /* eslint-disable no-param-reassign */
  if ((e.target as HTMLInputElement)?.files?.length != null) {
    const eTarget = e.target as FileEventTarget;
    const imageFile = eTarget.files[0];

    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 500,
      useWebWorker: true,
    };

    try {
      const base64CompressedImage = await imageCompression.getDataUrlFromFile(
        await imageCompression(imageFile, options)
      );
      e.target.value = "";
      return base64CompressedImage;
    } catch (error: unknown) {
      e.target.value = "";
      throw new Error("Error occured during compression !", { cause: error });
    }
  }
  /* On nettoie la sélection actuelle de l'input pour la prochaine sélection */
  e.target.value = "";
  throw new Error("Event target has no file !");
  /* eslint-enable no-param-reassign */
}

const imageUtil = {
  getBase64Data: getBase64DataFromFileSelection,
};
export default imageUtil;
